
import { RootState }      from '../store'
import { createSelector } from '@reduxjs/toolkit'

const loading = (state: RootState) => state.waterTestKits.loading
const error = (state: RootState) => state.waterTestKits.error
const data = (state: RootState) => state.waterTestKits.data || []

const makeLatestResult = createSelector([data], (items) => {
  const sorted = items.slice().sort((a, b) => {
    if (!a.createdAt || !b.createdAt) return 0
    if (a.createdAt! > b.createdAt!) return -1
    if (a.createdAt! < b.createdAt!) return 1
    return 0
  })
  return sorted[0]
})

const makeLatestAddress = createSelector(
  [makeLatestResult],
  item => {
    if(!item || !item.address) return ''
    const {address1, address2, city, state,  zip} = item.address || {}
    return `${address1} ${address2} ${city}, ${state} ${zip}`

  }
)

const makeLatestCity = createSelector(
  [makeLatestResult],
  item => {
    if(!item || !item.address) return ''
    const { city, state } = item.address || {}
    return `${city}, ${state}`
  }
)

export const WaterTestKitRequestsSelectors = {
  loading,
  error,
  data,
  makeLatestResult,
  makeLatestAddress,
  makeLatestCity,
}